// extracted by mini-css-extract-plugin
export default {"root":"UnderConstructionPage_root__UV9Ik","img":"UnderConstructionPage_img__NkZtW","title":"UnderConstructionPage_title__iHbdI","text":"UnderConstructionPage_text__aSvYu"};